import { render, staticRenderFns } from "./FollowUpPatientStep7Component.vue?vue&type=template&id=0c12695a&scoped=true&"
import script from "./FollowUpPatientStep7Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep7Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep7Component.vue?vue&type=style&index=0&id=0c12695a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c12695a",
  null
  
)

export default component.exports